import {
    ENABLE_ANALYTICS_ON_BY_DEFAULT,
    ENABLE_US_STATE_BANNER_FORMAT,
} from '/b2b/common/components/FeatureFlag/constants';
import {
    getCmpAnalyticsOnByDefaultEnabled,
    getCmpUsJurisdictionCustomizationEnabled,
} from '/b2b/authentication/state/customer/AuthCustomer.selectors';

import { isFeatureEnabled } from '/b2b/authentication/state/user/AuthUser.selectors';

export const getAnalyticsOnByDefaultAllowed = state =>
    isFeatureEnabled(state, ENABLE_ANALYTICS_ON_BY_DEFAULT) &&
    getCmpAnalyticsOnByDefaultEnabled(state);

export const getUsBannerFormatAllowed = state =>
    isFeatureEnabled(state, ENABLE_US_STATE_BANNER_FORMAT) &&
    getCmpUsJurisdictionCustomizationEnabled(state);
